// Deployment supplies the native API URL; an unset value stays on this origin.
export const API_BASE = process.env.REACT_APP_LISTINGS_API_BASE || '/api';

export const ADMIN_BASE =
  process.env.REACT_APP_ADMIN_BASE_URL || 'https://admin.dmre.com';
